import { Component } from "solid-js";

interface ElectronicsIconProps {
  class?: string;
}

export const ElectronicsIcon: Component<ElectronicsIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M17.3334 22.6666H5.33341C3.86066 22.6666 2.66675 21.4727 2.66675 20V7.99998C2.66675 6.52722 3.86066 5.33331 5.33341 5.33331H24.0001C25.4728 5.33331 26.6667 6.52722 26.6667 7.99998V10.6666"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 26.6667H13.3333"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="17.3333"
        y="10.6667"
        width="12"
        height="17.3333"
        rx="2.07362"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <ellipse
        cx="23.3333"
        cy="22.6666"
        rx="2.33333"
        ry="2.33333"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.6667 15.3337C23.6665 15.5176 23.5173 15.6666 23.3333 15.6666C23.1493 15.6665 23.0002 15.5174 23.0001 15.3334C23 15.1494 23.149 15.0001 23.333 14.9999C23.4215 14.9998 23.5065 15.0349 23.5691 15.0975C23.6317 15.1601 23.6669 15.2451 23.6667 15.3337"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
